import axios from 'axios';
import i18n from "../plugins/i18n";

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL
});

axiosInstance.interceptors.request.use(
    config => {
        let isAdminRoute = config.url.split('/').includes('admin');
        let tokenName    = isAdminRoute ? 'admin_token' : 'home_token';
        config.headers.Authorization = localStorage.getItem(tokenName);
        config.headers.common['Accept-Language'] = i18n.locale;
        return config;
    },
    error => Promise.reject(error)
);



export default axiosInstance;